import Vue from 'vue';
import store from './../../store';
import creditNoteReasonTransformer from './../../transformers/creditNoteReason';

const success = ({ data }, resolve) => {
  const creditNoteReasons = creditNoteReasonTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllCreditNoteReasons', creditNoteReasons);
  resolve(creditNoteReasons);
};

const failed = () => {};

// Display credit note reasons.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('credit_note_reason')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/creditNoteReason/all.js